<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAnalyticsProgress_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M13.72 7.806c.19.326.61.438.937.25a.68.68 0 0 0 .251-.932L13.294 4.34a.687.687 0 0 0-.994-.213.68.68 0 0 0-.286.366l-1.658 5.082-1.807-3.721a.69.69 0 0 0-.72-.378.69.69 0 0 0-.548.405L5.566 9.794l-1.149-1.98a.69.69 0 0 0-.573-.34.69.69 0 0 0-.61.29l-2.111 3.02a.68.68 0 0 0 .171.95c.31.214.738.138.954-.171l1.509-2.158 1.255 2.163a.687.687 0 0 0 1.144.066.7.7 0 0 0 .22-.275l1.576-3.596 1.867 3.843a.69.69 0 0 0 .57.384.686.686 0 0 0 .771-.462l1.7-5.206z"
        clip-rule="evenodd"
    />
</svg>
